var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-avatar',{class:_vm.avatarClass,staticStyle:{"z-index":"1"},attrs:{"id":"avatar-user","size":_vm.size,"variant":"primary","text":_vm.userInitials,"src":_vm.profilePreview || _vm.profilePicture}})}
var staticRenderFns = []

export { render, staticRenderFns }